const ToursDestinationsNoResults = () => {
    return (
        <>
            <h3
                style={{
                    color: "#ed6f6f",
                    fontWeight: "bold",
                }}
            >
                No Packages Available at the Moment.
            </h3>
            <h5
                style={
                    {
                        // color: "#ed6f6f",
                        // fontWeight: "bold",
                    }
                }
            >
                Change filtering options to discover more!
            </h5>
        </>
    );
};

export default ToursDestinationsNoResults;
